import React from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { useIntl } from 'react-intl';
import useUser from 'hooks/useUser';
import useCustomer from 'hooks/useCustomer';
import { Select } from 'antd';
import messages from 'translations/messages';
import NoAccessTag from 'components/NoAccessTag';

const QUERY = gql`
  query($customerId: ID!) {
    websites(customerId: $customerId) {
      id
      title
    }
  }
`;

const WebsiteSelect = ({ customerId, value, onChange, allowClear, ...rest }) => {
  const { formatMessage: $t } = useIntl();
  const { customer } = useCustomer();
  const { hasWebsiteAccess } = useUser();

  const { loading, data } = useQuery(QUERY, {
    variables: { customerId: customerId || customer?.id },
    skip: !(customerId || customer?.id),
  });

  const options = data?.websites.map(w => {
    const hasAccess = hasWebsiteAccess(w.id);
    return {
      value: w.id,
      disabled: !hasAccess,
      label: (
        <>
          {w.title}
          {!hasAccess && <NoAccessTag style={{ marginLeft: '.5em' }} />}
        </>
      ),
    };
  });

  return (
    <Select
      loading={loading}
      value={loading ? undefined : value}
      onChange={onChange}
      showSearch
      optionFilterProp="children"
      placeholder={$t(messages[allowClear ? 'allWebsites' : 'selectWebsite'])}
      allowClear={allowClear}
      options={options}
      {...rest}
    />
  );
};

export default WebsiteSelect;
